import React from "react";
import Datatable from "./datatable";
import ContentWrapper from "src/components/layouts/content-wrapper";

const Hubs = () => {
  return (
    <ContentWrapper>
      <Datatable />
    </ContentWrapper>
  );
};

export default Hubs;
